import { AspCancelInvoiceRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useCancelAspInvoice() {
  const api = useApi();
  const [cancelling, setCancelling] = useState(false);

  async function cancelAspInvoice(params: AspCancelInvoiceRequest) {
    try {
      setCancelling(true);
      const res = await api.cancelAspInvoice(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setCancelling(false);
    }
  }

  return { cancelling, cancelAspInvoice };
}
